import { createApi } from '@reduxjs/toolkit/query/react'

import { GetWopiResponse } from './documentApi.types'
import { editorType } from './editorSlice'
import { baseQueryWithReauth } from '../../../../redux-store/services/services.utils'

export const wopiApi = createApi({
  reducerPath: 'wopiApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getWopiUrl: builder.query<GetWopiResponse, string>({
      query: (docId) => `/wopi/${docId}`,
    }),
    getEditor: builder.query<{ id: editorType }, null>({
      query: () => '/wopi/editor',
    }),
  }),
})
